module.exports = __webpack_public_path__ + "img/img_placeholder.1d7cb234.jpg";